import store from '../store'
import keys from '../../keys.js'
var firebase = require('firebase/app')
require('firebase/messaging')

// Your web app's Firebase configuration
var firebaseConfig = {
  messagingSenderId: keys().fcmSenderId
}
const firebaseMessaging = firebase.messaging

if (firebaseMessaging.isSupported()) {
  // Initialize Firebase
  console.log('TCL: firebaseMessaging.isSupported()', firebaseMessaging.isSupported())
  firebase.initializeApp(firebaseConfig)
  firebaseMessaging().usePublicVapidKey(keys().fcmPublicVapidKey)
}

const askNotificationPermission = () => firebaseMessaging().requestPermission()

const setupNotification = async function () {
  try {
    if (firebaseMessaging.isSupported()) {
      console.log('TCL: Notification.permission', Notification.permission)
      if (Notification.permission === 'granted') {
        /* do our magic */
        store.dispatch('user/fetchFcmToken')
      } else if (Notification.permission === 'denied') {
        throw Error('Notification is blocked')
        /* the user has previously denied push. Can't reprompt. */
      } else {
        /* show a prompt to the user */
        console.log('TCL: show a prompt to the user')
        await askNotificationPermission()
        store.dispatch('user/fetchFcmToken')
      }
    } else {
      console.log('fcm not supported')
    }
  } catch (error) {
    console.log('TCL: setUpNotification -> error', error)
  }
}

export {
  firebaseMessaging,
  setupNotification,
}
